module.exports = __webpack_public_path__ + "img/pensativa.943528b7.png";